import React from 'react';

import CategoryListComponent from './CategoryListComponent.jsx';
import DateTimeRangeComponent from './DateTimeRangeComponent.jsx';
import MonthDayRangeComponent from './MonthDayRangeComponent.jsx';
import NumericRangeComponent from './NumericRangeComponent.jsx';
//import NumericDecimalsComponent from './NumericDecimalsComponent.jsx';

// Component for updating attribute filter ranges (NOT X, Y, Y2 Axis Ranges)
function RangeFilterComponent({ Dyn, type, resetFilter, isFiltered, attribute, reduceCaseCardWidth, handleChange }) {
    const types = type.split(":"),
        dataType = types[0],
        subType = types[1];

    if (dataType === "categorical") {
        return (
            <CategoryListComponent
                Dyn={Dyn}
                handleChange={handleChange}
                resetFilter={resetFilter}
                isFiltered={isFiltered}
                attributeObj={attribute}
                reduceCaseCardWidth={reduceCaseCardWidth}
            />
        );
    } else {
        //Check further numerical type to get relevant option for filter
        if (
            subType == "date" ||
            subType == "time" ||
            subType == "datetime" ||
            subType == "yearMonth" ||
            subType == "monthYear"
        ) {
            return (
                <DateTimeRangeComponent
                    Dyn={Dyn}
                    mode={subType}
                    handleChange={handleChange}
                    resetFilter={resetFilter}
                    isFiltered={isFiltered}
                    attributeObj={attribute}
                    reduceCaseCardWidth={reduceCaseCardWidth}
                />
            );
        } else if (subType == "month" || subType == "dayOfWeek") {
            return (
                <MonthDayRangeComponent
                    Dyn={Dyn}
                    mode={subType}
                    handleChange={handleChange}
                    resetFilter={resetFilter}
                    isFiltered={isFiltered}
                    attributeObj={attribute}
                    reduceCaseCardWidth={reduceCaseCardWidth}
                />
            );
        } else {
            // subType === undefined, "duration", "durationHM", "extractedNumber", "fraction", "year"
            return <NumericRangeComponent
                    Dyn={Dyn}
                    key="numericalRangeComponent"
                    handleChange={handleChange}
                    resetFilter={resetFilter}
                    attributeObj={attribute}
                    isFiltered={isFiltered}
                    reduceCaseCardWidth={reduceCaseCardWidth}
                />;
                // MOVED to AttributeEditComponent.jsx :
                // <NumericDecimalsComponent
                //     Dyn={Dyn}
                //     key="numericalDecimalComponent"
                //     handleChange={handleChange}
                //     attributeObj={attribute}
                //     isFiltered={isFiltered}
                //     reduceCaseCardWidth={reduceCaseCardWidth}
                // />,
            //];
        }
    }
}

export default RangeFilterComponent;
